import { useSyncExternalStore } from 'react'

/**
 * The reaction rate limiter's pause: raised by the API client the moment a
 * response carries its error key, shown by ReactionPauseModal at the app root
 * as a modal with an OK button, so no screen has to wire it and none can
 * forget to. A toast was too easy to miss for a message that explains why
 * nothing reacts for an hour.
 */
let current: string | null = null
const listeners = new Set<() => void>()

function notify() {
  listeners.forEach((listener) => listener())
}

export function raiseReactionPause(message: string) {
  current = message
  notify()
}

export function clearReactionPause() {
  current = null
  notify()
}

export function useReactionPause(): string | null {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
    () => current,
  )
}
